import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./lib/auth";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Activation from "./pages/Activation";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Repertoire from "./pages/Repertoire";
import DevisList from "./pages/DevisList";
import DevisBuilder from "./pages/DevisBuilder";
import Pipeline from "./pages/Pipeline";
import Leads from "./pages/Leads";
import Poc from "./pages/Poc";
import Recurrent from "./pages/Recurrent";
import Tickets from "./pages/Tickets";
import Tresorerie from "./pages/Tresorerie";
import Bons from "./pages/Bons";
import ImportPage from "./pages/ImportPage";
import ExportPage from "./pages/ExportPage";
import Parametrage from "./pages/Parametrage";

function Guard({ children, managerOnly }: { children: React.ReactElement; managerOnly?: boolean }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (managerOnly && user.role !== "manager") return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/activation" element={<Activation />} />
          <Route path="/forgot" element={<ForgotPassword />} />
          <Route path="/reset" element={<ResetPassword />} />
          <Route
            element={
              <Guard>
                <Layout />
              </Guard>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/repertoire" element={<Repertoire />} />
            <Route path="/devis" element={<DevisList />} />
            <Route path="/devis/nouveau" element={<DevisBuilder />} />
            <Route path="/devis/:id" element={<DevisBuilder />} />
            <Route path="/pipeline" element={<Pipeline />} />
            <Route path="/leads" element={<Leads />} />
            <Route path="/poc" element={<Poc />} />
            <Route path="/recurrent" element={<Recurrent />} />
            <Route path="/tickets" element={<Tickets />} />
            <Route
              path="/tresorerie"
              element={
                <Guard managerOnly>
                  <Tresorerie />
                </Guard>
              }
            />
            <Route
              path="/bons-commande"
              element={
                <Guard managerOnly>
                  <Bons />
                </Guard>
              }
            />
            <Route
              path="/import"
              element={
                <Guard managerOnly>
                  <ImportPage />
                </Guard>
              }
            />
            <Route
              path="/export"
              element={
                <Guard managerOnly>
                  <ExportPage />
                </Guard>
              }
            />
            <Route
              path="/parametrage"
              element={
                <Guard managerOnly>
                  <Parametrage />
                </Guard>
              }
            />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
